module.exports = "/_next/static/images/gd-64b1a583ba78c7ef09d19a3109aa5fd6.svg";